export function parseAgentMessageContent(content: unknown) {
  let parsedContent: string | { text: string } = '';

  if (typeof content === 'string') {
    try {
      const maybeObj: unknown = JSON.parse(content);
      if (typeof maybeObj === 'string') {
        parsedContent = { text: maybeObj };
      } else if (typeof maybeObj === 'object' && maybeObj !== null && 'text' in maybeObj) {
        parsedContent = maybeObj as { text: string };
      } else {
        parsedContent = { text: content };
      }
    } catch {
      parsedContent = { text: content };
    }
  } else if (typeof content === 'object' && content !== null) {
    if ('text' in content) {
      parsedContent = content as { text: string };
    } else if (
      'output' in content &&
      typeof content.output === 'object' &&
      content.output !== null &&
      'text' in content.output
    ) {
      parsedContent = { text: (content.output as { text: string }).text };
    } else if ('error' in content) {
      parsedContent = { text: (content.error as { message: string }).message };
    }
  } else {
    parsedContent = { text: String(content) };
  }

  return parsedContent;
}
